export default __webpack_public_path__ + "static/media/back-btn.301077f3.svg";